import { Box, Tab, Tabs, Typography, useMediaQuery } from "@mui/material"
import { useTranslations } from "next-intl"

export const CTLoginFlowHeadingsAndTabs = ({ activeTab, setActiveTab }: { activeTab: number, setActiveTab: (tab: number) => void }) => {
    const isMobile = useMediaQuery(theme => theme.breakpoints.down('md'))
    const t = useTranslations('otpModal')
    return (
        <Box>
            <Typography fontSize={isMobile ? 18 : 16} fontWeight={700} textAlign={isMobile ? 'center' : 'left'} marginBottom={'4px'}>
                {t('signInWithCleartrip')}
            </Typography>
            <Typography fontSize={12} fontWeight={400} color="text.secondary" textAlign={isMobile ? "center" : "left"}>
                {t('signInWithCleartripDescriptionDesktop')}
            </Typography>

            <Tabs
                value={activeTab}
                onChange={(_, v: number) => setActiveTab(v)}
                variant="fullWidth"
            >
                <Tab label={t('cleartripLoginFlow.mobileTabLabel')} value={0} />
                <Tab label={t('cleartripLoginFlow.emailTabLabel')} value={1} />
            </Tabs>
        </Box>
    )
}
